<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Member Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              Back
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7 black--text">
            <v-row>
              <v-col cols="10" sm="8" md="4" class="my-auto text-center">
                <v-avatar
                  size="250"
                  v-if="member && member.profile_url != null"
                  tile
                  class="cursor-pointer ml-3 rounded-xl"
                >
                  <v-img
                    :src="API_BASE_URL+'/uploads/'+member.profile_url"
                    :alt="member.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="success"
                  class="white--text cursor-pointer ml-3 rounded-xl text-h3" 
                  size="250"
                  tile
                >
                  <span>{{
                    member.name.charAt(0)
                  }}</span>
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.residentType") }}: </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ memberType(member.member_type) }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.name") }} : </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ member.name }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.mobileNo") }} : </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{
                      `${member.country_code}  ${member.mobile_no}`
                    }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.email") }} : </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ member.email ? member.email : 'N/A' }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.houseNo") }} : </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ member.house_number }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.flat") }} : </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ member.flat ? member.flat.name : 'N/A' }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold">{{ $t("society.list.members.details.business") }} : </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ member.business ? member.business : "N/A" }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      society_id: "",
      member_id: "",
      member: {
        name: '',
        flat: {
          name: '',
        }
      },
      memberTypes: [
        {
          id: "1",
          name: "Owner",
        },
        {
          id: "2",
          name: "Tenant",
        },
      ],
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getMemberDetails() {
      let _self = this;

      _self.$axios
        .get(`superadmin/society/${this.society_id}/members/${this.member_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.member = data.member;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    memberType(memberType) {
      let membertpye = this.memberTypes.find((type) => type.id == memberType);
      return membertpye ? membertpye.name : "N/A";
    },
  },
  mounted() {
    this.society_id = this.$route.params.id;
    this.member_id = this.$route.params.member_id;
    this.getMemberDetails();
  },
};
</script>